import React from 'react';
import { Checkbox } from 'antd';

interface Option {
  value: string;
  label: string;
  description?: string;
}

interface CheckboxSelectorProps {
  options: Option[];
  selectedValues?: string[];
  onChange: (values: string[]) => void;
  layout?: 'vertical' | 'horizontal';
  noDesc?: boolean;
}

const CheckboxSelector: React.FC<CheckboxSelectorProps> = ({
  options,
  selectedValues = [],
  onChange,
  layout = 'vertical',
  noDesc = false,
}) => {
  const handleCheckboxChange = (value: string) => {
    const currentValues = selectedValues || [];
    const newSelectedValues = currentValues.includes(value)
      ? currentValues.filter((val) => val !== value)
      : [...currentValues, value];

    onChange(newSelectedValues);
  };

  const isHorizontal = layout === 'horizontal';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: isHorizontal ? 'row' : 'column',
        gap: isHorizontal ? '24px' : '12px',
        flexWrap: isHorizontal ? 'wrap' : 'nowrap',
      }}
    >
      {options.map((opt) => {
        const isChecked = (selectedValues || []).includes(opt.value);

        return (
          <div
            key={opt.value}
            style={{
              display: 'flex',
              flexDirection: 'column',
              minWidth: isHorizontal ? '200px' : 'auto',
            }}
          >
            <Checkbox
              checked={isChecked}
              onChange={() => handleCheckboxChange(opt.value)}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <span style={{ fontWeight: 400, fontSize: '14px' }}>
                {opt.label}
              </span>
            </Checkbox>
            {!noDesc && opt.description && (
              <span
                style={{
                  marginLeft: 24,
                  fontSize: '12px',
                  color: 'var(--text-secondary)',
                  fontWeight: 400,
                }}
              >
                {opt.description}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CheckboxSelector;
